import { green, red } from '@mui/material/colors';
import IconeAdvogado from '../components/sessao/icones/IconeAdvogado';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de inscrição de advogado.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_INSCRICAO_ADVOGADO = {
    INSCRITO: { id: 'INSCRITO', descricao: 'Presença não informada', descricaoPresencaCurta: 'Sem informação', cor: 'black',    corFundo: 'inherit', codigo: 'NA' },
    PRESENTE: { id: 'PRESENTE', descricao: 'Advogado presente',      descricaoPresencaCurta: 'Presente',       cor: green[700], corFundo: 'inherit', codigo: 'S' },
    AUSENTE:  { id: 'AUSENTE',  descricao: 'Advogado ausente',       descricaoPresencaCurta: 'Ausente',        cor: red[900],   corFundo: 'inherit', codigo: 'N' }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de inscrição de advogado.
 * @readonly
 */
export default class SituacaoInscricaoAdvogado {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_INSCRICAO_ADVOGADO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_INSCRICAO_ADVOGADO =
        'Não foi possível identificar a situação da inscrição de advogado.';
    static DESCONHECIDO = 'Desconhecido';

    static getDescricao(id) {
        return SituacaoInscricaoAdvogado.situacaoBase.getDescricao(id);
    }

    static getDescricaoPresencaCurta(id) {
        return SituacaoInscricaoAdvogado.situacaoBase.getValorPropriedade(id, 'descricaoPresencaCurta');
    }

    static getDescricaoPresencaCurtaByCodigo(codigo) {
        const obj = SituacaoInscricaoAdvogado.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.warn(`Situação "${codigo}" desconhecida.`);
            return SituacaoInscricaoAdvogado.DESCONHECIDO;
        }

        return SituacaoInscricaoAdvogado.getDescricaoPresencaCurta(obj.id);
    }

    static getCor(id) {
        return SituacaoInscricaoAdvogado.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorByCodigo(codigo) {
        const obj = SituacaoInscricaoAdvogado.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.warn(`Situação "${codigo}" desconhecida.`);
        }

        return obj ? SituacaoInscricaoAdvogado.getCor(obj.id) : 'black';
    }

    static getCodigo(id) {
        return SituacaoInscricaoAdvogado.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getIcone(id) {
        const tamanhoIcone = '21px';
        const obj = SituacaoInscricaoAdvogado.situacaoBase.getObjectById(id);

        if (Object.hasOwn(obj, 'icone')) {
            return SituacaoInscricaoAdvogado.situacaoBase.getValorPropriedade(id, 'icone');
        }

        return (
            <IconeAdvogado
                removerTooltip
                removerEstiloPadrao
                style={{ width: tamanhoIcone, height: tamanhoIcone, color: obj.cor }}
            />
        );
    }
}
